<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let data;
  export let index;

  const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section class="story-thumbnail" data-slide-index={index} on:click={() => dispatch('click', index)}>
  <section class="thumbnail-image-area" style:background-color={data?.thumbnailBackgroundColor}>
    <img width="65" height="65" class="thumbnail-image" src={data?.thumbnailImageUrl} alt="Story Thumbnail" />
  </section>
  <h3 class="thumbnail-title">{@html data?.thumbnailTitle}</h3>
</section>

<style lang="scss">
  @import '../styles/colors.new.scss';

  .story-thumbnail {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;

    .thumbnail-image-area {
      border-radius: 50%;
    }
    img {
      border-radius: 50%;
      border: 2px dashed $functional-yellow;
      width: 65px;
      height: 65px;
      object-fit: cover;
    }
    h3 {
      margin-block: 0;
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }
  }
</style>
